module.exports = __webpack_public_path__ + "static/media/copy.80543c02.svg";